import type { CSSProperties } from 'react';

/** Avatar palitrasi — 8 rang (docs/DESIGN_TOKENS.md §3). */
export const PALETTE_SIZE = 8;

export type PaletteIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

/**
 * Foydalanuvchi rangi CSS o'zgaruvchilari.
 *
 * Indeks SERVERDAN keladi (`users.palette_idx`) — bu yerda `id % 8` bilan
 * hisoblanmaydi (D-042). Hisoblangan rang id o'zgarganda sakrab ketadi va
 * foydalanuvchi buni "akkauntim o'zgarib qoldi" deb qabul qiladi.
 */
export function paletteVars(idx: number): CSSProperties {
  const i = ((idx % PALETTE_SIZE) + PALETTE_SIZE) % PALETTE_SIZE;
  return {
    color: `var(--pal-${i}-fg)`,
    background: `var(--pal-${i}-bg)`,
  };
}
